@if (tegels().length > 0) {
	<div class="sectie">
		<h2 class="kop">Recent bekeken</h2>
		<div class="rij">
			@for (tegel of tegels(); track tegel.url) {
				<app-pagina-card [url]="tegel.url" [titel]="tegel.titel" [bovenschrift]="tegel.bovenschrift" (clickit)="open(tegel.url)" />
			}
		</div>
	</div>
}
